// よくあるご質問のアコーディオン

const triggers = document.querySelectorAll('.js-accordion__trigger');
// const targets = document.querySelectorAll('.js-accordion__target');

triggers.forEach((trigger) => {
	const target = trigger.nextElementSibling;
	trigger.addEventListener('click', () => {
		target.classList.toggle('open');
	});
});
